import PropTypes from 'prop-types';

import BookCard from 'uI/BookCard/BookCard';
import CourseCard from 'uI/CourseCard/CourseCard';
import UdcCard from 'uI/UdcCard/UdcCard';

const Items = props => {
  return (
    <>
      {props.section === 'book'
        ? props.itemsCard.map(item => (
            <BookCard key={item.keyBook} itemData={item} />
          ))
        : props.section === 'courses'
        ? props.itemsCard.map(item => (
            <CourseCard key={item.idCourse} itemData={item} />
          ))
        : props.itemsCard.map(item => (
            <UdcCard
              key={item.link}
              itemData={item}
              section={props.section}
            />
          ))}
    </>
  );
};

Items.propTypes = {
  // eslint-disable-next-line react/require-default-props
  itemsCard: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  section: PropTypes.string
};

export default Items;
